<div class="app-image"
     [class.app-image--ratio]="!!aspectRatio()"
     [class.app-image--fill]="fill()"
     [class.app-image--intrinsic]="intrinsic()"
     [class.is-loaded]="loaded()"
     [style.--ratio]="aspectRatio() || null"
>
<div class="app-image__skeleton skeleton-loading" aria-hidden="true"></div>

<picture>
  @if (placeholderSrc() && placeholderSrc()!.length > 0) {
    <img
      class="app-image__placeholder"
      [src]="placeholderSrc()"
      alt=""
      aria-hidden="true"
      decoding="async"
      loading="eager" />
  }

  @if (avifSrcset()) {
    <source type="image/avif" [attr.sizes]="sizes()" [attr.srcset]="avifSrcset()" />
  }

  @if (webpSrcset()) {
    <source type="image/webp" [attr.sizes]="sizes()" [attr.srcset]="webpSrcset()" />
  }

  <img
    class="app-image__img {{ imgClass() }}"
    [class.app-image__img--contain]="fit() === 'contain'"
    [src]="fallbackSrc()"
    [attr.data-key]="fallbackSrc()"
    [attr.alt]="ariaHidden() ? null : alt()"
    [attr.aria-hidden]="ariaHidden()"
    [attr.loading]="priority() ? 'eager' : 'lazy'"
    [attr.fetchpriority]="priority() ? 'high' : null"
    decoding="async"
    [attr.width]="width() || null"
    [attr.height]="height() || null"
    (load)="onLoad()"
    (error)="onError()"
  />
</picture>
</div>
